<template>
  <div class="display-ticket-check-result-wrapper">
    <div class="content-wrapper">
      <van-icon name="passed" color="#07C160" size="120" v-if="succeed" />
      <van-icon name="close" color="#E8534F" size="120" v-else />

      <div class="description-wrapper">
        <div v-if="succeed">
          <p>核销成功</p>
          <p>【{{ text }}】</p>
        </div>
        <div v-else class="failed">
          <p>核销失败</p>
          <p>{{ text }}</p>
        </div>
      </div>

      <van-count-down format="ss" :time="1000 * 60" @finish="back">
        <template v-slot="timeData">
          <van-button :color="succeed ? 'primary' : '#E8534F'" size="large" @click="back">
            继续核销 {{ timeData.seconds }} 秒
          </van-button>
        </template>
      </van-count-down>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    succeed() {
      return this.$route.query.type === 'success';
    },
    text() {
      return this.$route.query.text;
    },
  },
  methods: {
    back() {
      this.$router.replace({ name: 'venue_ticket_check' });
    },
  },
};
</script>
<style lang="less" scoped>
.display-ticket-check-result-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  .content-wrapper {
    margin: 40px 16px;
    text-align: center;
    .description-wrapper {
      padding: 16px;
      font-size: 18px;
      line-height: 26px;
    }
    .van-button {
      border-radius: 8px;
    }
  }
}
</style>
